/**
 * @desc 推送sku到srm
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/pushSkuListToSrm`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
